import axiosInstance from "../helpers/axios";

// func for getting all details of the device based on api 
export interface AllProfileFilters {
    sortBy?: string;
    sortOrder?: "asc" | "desc";
    page?: number;
    limit?: number;
    search?: string;
    deviceType?: string;
    templateName?: string;
    mode?: string;
    activeStatus?: string; // "true" or "false"
    startDate?: string;
    endDate?: string;
}

// func for getting all details of the device based on api 
export const allDeviceApi = async (filters?: AllProfileFilters) => {
    try {
        const params = new URLSearchParams();

        if (filters?.sortBy) params.append("sortBy", filters.sortBy);
        if (filters?.sortOrder) params.append("sortOrder", filters.sortOrder);
        if (filters?.page) params.append("page", filters.page.toString());
        if (filters?.limit) params.append("limit", filters.limit.toString());
        if (filters?.search) params.append("search", filters.search);
        if (filters?.deviceType) params.append("deviceType", filters.deviceType);
        if (filters?.templateName) params.append("templateName", filters.templateName);
        if (filters?.mode) params.append("mode", filters.mode);
        if (filters?.activeStatus) params.append("activeStatus", filters.activeStatus);
        if (filters?.startDate) params.append("startDate", filters.startDate);
        if (filters?.endDate) params.append("endDate", filters.endDate);

        const queryString = params.toString();
        const url = `/profiles/allProfiles${queryString ? `?${queryString}` : ""}`;

        const allDevice = await axiosInstance.get(url);
        return allDevice.data
    }
    catch (error) {
        console.log(error)
    }
}

// func for getting all details of the device based on api 
export const replaceDeviceApi = async (replaceObj: any) => {
    try {
        const allDevice = await axiosInstance.put("/device/replaceDevice", replaceObj);
        return allDevice.data

    }
    catch (error) {
        console.log(error)
    }
}

// func for activate  of the device based on api t
export const activateDeviceApi = async (obj: any) => {
    try {
        const allDevice = await axiosInstance.put("/device/activateDevice", obj);
        return allDevice.data

    }
    catch (error) {
        console.log(error)
    }
}

// func for deActivate  of the device based on api t
export const deActivateDeviceApi = async (obj: any) => {
    try {
        const allDevice = await axiosInstance.put("/device/deActiveDevice", obj);
        return allDevice.data

    }
    catch (error) {
        console.log(error)
    }
}

// func for add new  device based on api 
export const addDeviceApi = async (obj: any) => {
    try {
        const addDevice = await axiosInstance.post("/device/createDevice", obj);
        return addDevice.data
    }
    catch (error) {
        console.log(error)
    }
}

// func for getting all  device based on api 
export const getAllDeviceApi = async () => {
    try {
        const allDevices = await axiosInstance.get("/device/allDevice");
        return allDevices.data
    }
    catch (error) {
        console.log(error)
    }
}

// func for edit  device based on api 
export const updateDeviceApi = async (obj: any) => {
    try {
        const allDevices = await axiosInstance.put("/device/updateDevice", obj);
        return allDevices.data
    }
    catch (error) {
        console.log(error)
    }
}

export interface ProfileAnalyticsFilters {
    sortBy?: string;
    sortOrder?: "asc" | "desc";
    page?: number;
    limit?: number;
    search?: string;
    planId?: number;
    startDate?: string;
    endDate?: string;
}

export const getProfileAnalyticsApi = async (filters?: ProfileAnalyticsFilters) => {
    try {
        const params = new URLSearchParams();

        if (filters?.sortBy) params.append("sortBy", filters.sortBy);
        if (filters?.sortOrder) params.append("sortOrder", filters.sortOrder);
        if (filters?.page) params.append("page", filters.page.toString());
        if (filters?.limit) params.append("limit", filters.limit.toString());
        if (filters?.search) params.append("search", filters.search);
        if (filters?.planId) params.append("planId", filters.planId.toString());
        if (filters?.startDate) params.append("startDate", filters.startDate);
        if (filters?.endDate) params.append("endDate", filters.endDate);

        const queryString = params.toString();
        const url = `/users/getAnalyticsUserProfiles${queryString ? `?${queryString}` : ""}`;

        const response = await axiosInstance.get(url);
        return response.data;
    }
    catch (error) {
        console.log(error);
        return null;
    }
}